import { slab, wallX, wallZ, goal, shard, sign, neon, checkpoint, edgeLights } from '../kit.js';

const pad = (x, y, z, w = 7, d = 7, m = 'plate') => [
  slab(x, y, z, w, d, m, 1.0),
  ...edgeLights(x, y, z, w, d, 'amber'),
];

/**
 * Vertical flinging. The deck you stand on is itself portal ready, so the
 * exit can be placed at your feet: drop 78 metres into the pit and the same
 * 78 metres comes back out of the floor pointing straight up.
 */
export default {
  id: 'uplink',
  name: 'UPLINK',
  blurb: 'Down is how you get up. Collect the shards.',
  mode: { type: 'collect', par: 95 },
  redline: { seconds: 86 },   // docs/REDLINE.md; seeded from the board, honesty pass pending
  spawn: { p: [0, 0.4, 10], yaw: 0 },
  killY: -210,
  env: {
    fog: 0x08181f,
    fogDensity: 0.0038,
    sky: { zenith: 0x030a10, horizon: 0x0b2430, glow: 0x1c7a72, aurora: 0x18b0c8 },
    floorY: -340,
  },
  objects: [
    // ---- the deck: portalable floor, which is the whole trick
    slab(0, 0, 0, 30, 32, 'panel', 1.4),
    ...edgeLights(0, 0, 0, 30, 32, 'cyan'),
    wallX(-15.7, 0, 0, 32, 5, 'plate', 1.4),
    wallX(15.7, 0, 0, 32, 5, 'plate', 1.4),
    wallZ(0, 0, 16.7, 31, 5, 'plate', 1.4),

    // ---- the pit, immediately north of the deck. Near wall tucked under the
    // deck so the floor of the pit is visible from the lip.
    wallZ(0, -78, -15.25, 28, 78, 'plate', 1.5),
    wallZ(0, -78, -40.75, 28, 78, 'plate', 1.5),
    wallX(-13.25, -78, -28, 24, 78, 'plate', 1.5),
    wallX(13.25, -78, -28, 24, 78, 'plate', 1.5),
    slab(0, -78, -28, 26, 24, 'panel', 1.5),
    neon(0, -77.4, -28, [24, 0.16, 0.16], 'magenta'),
    neon(-12.4, -39, -28, [0.16, 76, 0.16], 'cyan'),
    neon(12.4, -39, -28, [0.16, 76, 0.16], 'cyan'),

    // ---- the climb: platforms spiralling up around the deck. The first
    // two pads are wider and pad one holds a checkpoint: the launch-era
    // funnel measured a 13% clear rate against ~45% for the neighbors, and
    // the wall was the climb resetting to the fling on every fall.
    ...pad(14, 18, 4, 10, 10),
    checkpoint(14, 18, 4),
    ...pad(-13, 30, -6, 9, 9),
    ...pad(10, 44, -14, 9, 9),
    ...pad(-15, 56, 2, 9, 9),
    ...pad(4, 70, 12, 10, 10),

    shard(14, 20, 4),
    shard(-13, 32, -6),
    shard(10, 46, -14),
    shard(-15, 58, 2),
    shard(4, 72, 12),

    // ---- exit terrace
    slab(16, 62, -18, 16, 16, 'plate', 1.2),
    ...edgeLights(16, 62, -18, 16, 16, 'lime'),
    wallZ(16, 62, -25.6, 17, 7, 'plate', 1.2),
    goal(16, 62, -22, 0),
    checkpoint(16, 62, -14),

    neon(0, 0.1, 0, [28, 0.1, 0.1], 'cyan', { light: true, intensity: 30, range: 34 }),

    // ---- guidance
    sign(0, 3.4, 6, 0, [
      'UPLINK',
      'PORTAL THE PIT FLOOR',
      'PORTAL THE DECK AT YOUR FEET',
    ]),
    sign(0, 2.0, -14, 0, ['STEP IN', 'COME OUT VERTICAL'], '#ffb020'),
    sign(-10, 4.4, 2, 0, ['5 SHARDS OPEN THE GATE'], '#ffb020'),
    sign(14, 21.2, 7, 0, ['CHECKPOINT HELD', 'A FALL COSTS THE CLIMB', 'NEVER THE FLING'], '#ffb020'),

    // The fling, DEMONSTRATED: quitters here die zero deaths (measured),
    // which means the concept fails to land, not the execution. A looping
    // hologram walks the lip, drops the pit, blinks out of the deck, and
    // rides the arc to pad one. Communication, not difficulty.
    { t: 'demo',
      path: [
        [0, 0, 0.4, -6], [1.6, 0, 0.4, -14.6], [2.0, 0, -6, -18],
        [3.2, 0, -50, -24], [4.2, 0, -75, -27],
        [4.24, 0, 0.6, -4],
        [5.4, 0, 42, 0], [6.6, 0, 74, 3],
        [8.0, 6, 46, 4], [9.2, 14, 22, 4], [9.8, 14, 18.4, 4],
      ] },
  ],
};
